import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './ipad.css';
import App from './App';
import './utils/i18n';
import { initAdobeLaunch, initDataLayer, initVirtualPageTracking } from './analytics';

const root = ReactDOM.createRoot(document.getElementById('root'));

const initAnalytics = () => {
  initAdobeLaunch();

  const language = localStorage.getItem('selectedLanguage') || 'en';

  initDataLayer({
    country_code: 'IT',
    page_template: 'landing',
    page_type: 'initial_load',
    site_language_code: language,
    '404': false,
    pagename: '/'
  });
  
  setTimeout(() => {
    initVirtualPageTracking();
  }, 1000);
};

initAnalytics();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
